import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/infinity-city.de/releases/2026-07-18_17-36-34/components/SiteHeader.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/infinity-city.de/releases/2026-07-18_17-36-34/components/Starfield.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/var/www/infinity-city.de/releases/2026-07-18_17-36-34/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/var/www/infinity-city.de/releases/2026-07-18_17-36-34/node_modules/next/dist/client/image-component.js");
